import { Flex, VStack, Text, chakra, HStack, Image, Button, Stack, useMediaQuery, Heading } from '@chakra-ui/react';
import checkmark from 'Assets/svg/Checkmark.svg';
import React from 'react';
import PhoneMarkup from 'Assets/Images/PhoneMarkup.png';
import PhoneMarkupMobile from 'Assets/Images/PhoneMarkupMobile.png';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import useLocalizedNavigate from 'Utils/useLocalizedNavigate';
import { AppRoutes } from 'Routes/AppRoutes';
import { ILoopBusinessLocalizationDocument } from 'Types/Interface/Sanity';

interface IGrowWithLoopProps{
	shouldIgnoreParentPadding: boolean;
	loopBusinessLocalization: ILoopBusinessLocalizationDocument | null;
}

export const GrowWithLoop = ({shouldIgnoreParentPadding, loopBusinessLocalization}:IGrowWithLoopProps) => {
	const [isLargerThan768] = useMediaQuery('(min-width: 984px)');
	const navigate = useLocalizedNavigate();


	return(
		<Flex 
			direction={['column', null, null, 'row']} 
			bg={['#FFFCFC', null, null, '#FFFCFC']} 
			backgroundSize={'cover'}
			// pt={[null,'80px']} 
			py={['40px','100px']}
			w={'100%'} 
			h={'auto'}
			justifyContent={'space-between'}
			{...(shouldIgnoreParentPadding && { px: {base: '30px', xl: '80px', '2xl': '192px' }})}
		>
			<VStack spacing={['30px','40px']} w={['100%', null, null, null, '50%', null]} align={'flex-start'}>
				<Stack spacing={[1,2]} >
					<Heading textTransform={'uppercase'} fontSize={['30px','40px']} fontWeight={'bold'}> Grow with </Heading>
					<Heading textTransform={'uppercase'} pb={'10px'} fontSize={['30px','40px']} fontWeight={'bold'}>
						First-Party <chakra.span textDecoration={'line-through'} fontWeight={400}>Data</chakra.span> <chakra.span color={'darkCoral'}>Relationships</chakra.span> <br/>  - From Every Channel
					</Heading>
					<Text fontSize={['16px','18px']}>
						{loopBusinessLocalization?.secondaryHeading}
					</Text>
				</Stack>
				
				<VStack spacing={['18px','30px']} justifyContent={'center'} align={'flex-start'}>
					{
						loopBusinessLocalization?.benefits.map((benefit: string, id: number) => {
							return(
								<HStack alignItems={'flex-start'} key={benefit + id}>
									<Image boxSize={'20px'} src={checkmark} />
									<Text color={'blackText.200'} fontSize={['16px','18px']}>{benefit}</Text>
								</HStack>
							);
						})
					}
				</VStack>
				<Text fontSize={['16px','20px']} color={'loopGrey.500'} fontWeight={'600'}>{loopBusinessLocalization?.description}</Text>
				<Button
					w={['auto','220px']}
					h={['40px','60px']}
					fontWeight={600}
					variant={'secondary'}
					onClick={() => navigate(AppRoutes.processOverview)}
				>
					Learn how it works
					<ArrowForwardIcon ml={2} boxSize={5} />
				</Button>
			</VStack>
			{ isLargerThan768 ? <Flex maxWidth={'50%'} bg={'#F5F5F5'} alignItems={'flex-end'} justifySelf={'center'}  w={['388px','auto']} h={['450px','650px']}>
				<Image w={['auto','610px']}  objectFit={['contain','cover']} h={['auto','548px']} src={PhoneMarkup} />
			</Flex> :
				<Flex alignItems={'flex-end'} justifyContent={'center'} mt={'50px'}  >
					<Image w={'610px'}  objectFit={'contain'} h={'auto'} src={PhoneMarkupMobile} />
				</Flex>
			}
		</Flex>
	);
};